module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"flag-icon-css-fr\" viewBox=\"0 0 640 480\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"#fff\" d=\"M0 0h640v480H0z\"/>\n    <path fill=\"#00267f\" d=\"M0 0h213.3v480H0z\"/>\n    <path fill=\"#f31830\" d=\"M426.7 0H640v480H426.7z\"/>\n  </g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./public/img/flags/4x3/fr.svg
// module id = 6n0y
// module chunks = 5